import { useRef, useMemo } from 'react'
import { warn, isObject, isArray } from '../../core'

/** 提供统一的不变的对象 */
export function useInvariable<T extends Object>(newValue: T) {

  const lastValue = useRef<T>()
  lastValue.current = newValue

  return useMemo<T>(() => {
    if (!(isObject(newValue) || isArray(newValue))) {
      warn('useInvariable接收类型只能为Object或Array')
      return newValue
    }
    const emptyObject = {}
    Object.keys(newValue).forEach(k => {
      // 添加代理提示对象
      Object.defineProperty(emptyObject, k, {
        get() {
          warn('请通过解构的方式拿到整个对象的值')
          return undefined
        },
        enumerable:   true,
        configurable: false
      })
    })
    return new Proxy<T>(emptyObject as unknown as T, {
      get(_, key, receiver) {
        return Reflect.get(lastValue.current!, key, receiver)
      },
      set() {
        return console.error('此对象不可写'), false
      }
    })
  }, [])

}